import axios from './httpConfig.js'
//******************出入库管理 -- 拆卸单 ******************/

// 拆卸单 列表
export function GetOrderList(param) {
	return axios.post('/admin/dismantle/order/list', param)
}

// 删除拆卸单 整个订单
export function DeleteOrder(param) {
	return axios.post('/admin/dismantle/order/delete', param)
}

// 单据的全部信息
export function GetOrderInfo(param) {
	return axios.post('/admin/dismantle/order/info', param)
}

// 删除已拆卸单 订单中的货品
export function DeleteGoods(param) {
	return axios.post('/admin/dismantle/order/goods/delete', param)
}

// 导出拆卸单订单列表
export function ExportOrderList(param) {
	return axios.postBlob('/admin/dismantle/order/export', param)
}

// 修改拆卸单主信息
export function EditMainInfo(param) {
	return axios.post('/admin/dismantle/order/edit', param)
}



// 修改已拆卸单SN
export function EditSN(param) {
	return axios.post('/admin/receipt/sn/edit', param)
} 
// 修改已拆卸单货位---todo暂无接口
export function EditGoodsLocation(param) {
	return axios.post('/admin/receipt/order/goods/edit', param)
} 

export const disassemblyRequest = {
	GetOrderList,
	DeleteOrder,
	DeleteGoods,
	GetOrderInfo,
	EditSN,
	EditMainInfo,
	EditGoodsLocation,
	ExportOrderList,
}